import * as Sentry from '@sentry/react';
import { Component, type ErrorInfo, type ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import i18n from '@/i18n/config';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Корневая граница ошибок: ловит непойманные исключения рендера и показывает
 * экран восстановления вместо «белого экрана». Репортит в Sentry (если подключён).
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex min-h-svh flex-col items-center justify-center gap-4 bg-background p-6 text-center">
        <div className="text-5xl" aria-hidden>
          😵
        </div>
        <h1 className="font-display text-xl font-extrabold tracking-tight">
          {i18n.t('common.appError')}
        </h1>
        <Button variant="primary" onClick={() => window.location.reload()}>
          {i18n.t('common.reload')}
        </Button>
      </div>
    );
  }
}
